import { POST } from "api";

export const saveChatHistoryToDB = async (token: string, nodeId: number, messages: any[]) => {
    const body = new URLSearchParams();
    body.append('userToken', token);
    body.append('option', String(nodeId));
    body.append('content', encodeURIComponent(JSON.stringify(messages)));
  
    try {
      const response = await POST('setUserContent', body);
      if (response.status !== 200) {
        console.error('Fehler beim Speichern des Chatverlaufs:', response);
      }
    } catch (err) {
      console.error('Netzwerkfehler beim Speichern:', err);
    }
  };

  export const loadChatHistoryFromDB = async (token: string, nodeId: number) => {
    const body = new URLSearchParams();
    body.append('userToken', token);
    body.append('option', String(nodeId));
  
    try {
      const response = await POST('getUserContent', body);
      if (response.status === 200 && response.result?.content) {
        return JSON.parse(decodeURIComponent(response.result.content));
      }
    } catch (err) {
      console.error('Fehler beim Laden des Chatverlaufs:', err);
    }
  
    return [];
  };
  